export enum VariablesAttributesActionTypes {
  LoadVariables = 'variablesAttributesActionTypes/loadVariables',
  LoadVariablesSuccess = 'variablesAttributesActionTypes/loadVariablesSuccess',
  LoadVariablesFailure = 'variablesAttributesActionTypes/loadVariablesFailure',
}
